import { ToastOptions, toast } from "react-toastify"
import { ToastContent } from "@/ui/ToastContent"

const defaultOptions: ToastOptions = {
  position: "bottom-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true
}

export const showToast = {
  success: (message: string, options?: ToastOptions) => {
    toast.success(<ToastContent>{message}</ToastContent>, {
      ...defaultOptions,
      ...options
    })
  },
  error: (message: string, options?: ToastOptions) => {
    toast.error(<ToastContent>{message}</ToastContent>, {
      ...defaultOptions,
      ...options
    })
  },
  info: (message: string, options?: ToastOptions) => {
    toast.info(<ToastContent>{message}</ToastContent>, {
      ...defaultOptions,
      ...options
    })
  },
  warning: (message: string, options?: ToastOptions) => {
    toast.warning(<ToastContent>{message}</ToastContent>, {
      ...defaultOptions,
      ...options
    })
  },
  default: (message: string, options?: ToastOptions) => {
    toast(<ToastContent>{message}</ToastContent>, {
      ...defaultOptions,
      ...options
    })
  }
}
